import { Field, ErrorMessage } from 'formik'
import { toPascalCase } from '../../utils/utils'
import InputLayout from 'components/layouts/InputLayout'
import { classNames } from 'utils/utils'
import { propFromName } from 'utils/utils'
import CustomInput from 'components/CustomInput'

/**
 * @typedef {object} CustomInputFormikProps
 * @property {string} props.label
 * @property {string} props.containerClassName
 * @property {React.CSSProperties} props.containerStyle
 * @property {boolean} props.inline
 * @property {boolean} props.showError
 */

/**
 * 
 * @param {CustomInputFormikProps & import('components/CustomInput').CustomInputProps} props 
 * @returns 
 */
export default function CustomInputFormik({
    name='', label='', type='text', 
    containerClassName, 
    containerStyle, 
    inline=false, 
    showError=true,
    info,
    ...props
}) {
    
    const input = ({field, form: {errors, touched}}) => {
        if (propFromName(touched, name) && propFromName(errors, name)) props.isInvalid = true
        return <CustomInput {...field} {...props} type={type} />
    }

    return (
        <InputLayout 
            label={label ? label : toPascalCase(name)}
            className={classNames(['input-formik', containerClassName])}
            style={containerStyle}
            inline={inline}
            info={info}
        >
            <Field name={name}>{input}</Field>
            { name && showError ? <ErrorMessage name={name}>{msg => <div className='invalid-feedback'>{msg}</div>}</ErrorMessage> : null}
        </InputLayout>
    )
}